import React from 'react';
import styled from 'styled-components';
import Header from '../../Molecule/Card/CardHeader';
import Title from '../../Molecule/Card/CardTitle/ChartTitle';
import TreemapChart from '../../Molecule/Chart/TreemapChart';
import Spinner from '../../Molecule/Spinner';

const Component = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  width: 100%;
  height: 100%;
  min-height: 579px;
  padding: 24px 24px 40px 24px;
  border-radius: 16px;
`;

const Body = styled.div`
  position: relative;
  flex: 1;
  width: 100%;
  margin-top: 24px;
`;

interface TreemapChartCardProps {
  data: {
    total: number;
    old: number;
    new: number;
    local_variant_en: string;
    local_variant_ko: string;
  }[];
  isLoading: boolean;
}

const TreemapChartCard = ({ data, isLoading }: TreemapChartCardProps) => {
  return (
    <Component>
      <Header>
        <Title title="국내 방문자" />
      </Header>
      <Body>{isLoading ? <Spinner /> : <TreemapChart data={data} />}</Body>
    </Component>
  );
};

export default TreemapChartCard;
